exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._map{width:100%;height:600px;display:flex;align-items:center}._map .vue-map-container{flex:1}._map .no-map-message{text-align:center;font-size:25px;color:#dc2814}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/components/plain/map/map.styl
// module id = 437
// module chunks = 0